var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 1",
    clipPath: "url(#clip0_311_251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M50.0962 40.9045L33.4562 24.2623L30.399 27.2913L19.544 16.4363V7.41433L6.78016 0.0541667L0.0959897 6.73617L7.45832 19.5H16.4803L27.3202 30.3398L24.2197 33.41L40.903 50.0955C42.1315 51.3218 43.763 52 45.5007 52C47.2383 52 48.8698 51.324 50.0962 50.0955C52.6312 47.5605 52.6312 43.4395 50.0962 40.9045ZM18.0988 33.4187L21.1842 30.3333L16.8313 25.9805L1.90516 40.9045C-0.629844 43.4395 -0.629844 47.5605 1.90516 50.0955C3.13366 51.3218 4.76516 52 6.50282 52C8.24049 52 9.87199 51.324 11.0983 50.0955L22.9392 38.2547L18.101 33.4165L18.0988 33.4187ZM50.0918 8.79233C51.3008 11.1258 51.914 13.6348 51.914 16.25C51.914 21.7728 49.1385 26.6565 44.9135 29.5923L33.4713 18.1502L30.412 21.177L23.8752 14.6402V5.1025C26.8392 1.9695 31.0187 0 35.6618 0C38.2207 0 40.6842 0.589333 42.9873 1.75717L43.6785 2.10817L35.9348 9.9385C34.2427 11.6307 34.2427 14.3737 35.9348 16.0658C37.627 17.758 40.37 17.758 42.0622 16.0658L49.8037 8.23983L50.0897 8.7945L50.0918 8.79233Z",
    fill: "#660066"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_311_251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.d853c8ae75e5a5db22be1b47ab1b5152.svg";
export { ForwardRef as ReactComponent };